import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateFeeStructureForm from "../../forms/CreateOrUpdateFeeStructureForm";
import { FeeStructureResponseDto } from "../../shared/dtos/feeStructure/FeeStructureResponseDto";

interface UpdateFeeStructureModalProps {
  open: boolean;
  onClose: () => void;
  feeStructure: FeeStructureResponseDto;
  userInfo?: any;
  loading: boolean;
  error: string | null;
}

const UpdateFeeStructureModal: React.FC<UpdateFeeStructureModalProps> = ({
  open,
  onClose,
  feeStructure,
  userInfo,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Edit Fee Allocation"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateFeeStructureForm
      isEditing={true}
      feeStructure={feeStructure}
      userInfo={userInfo}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateFeeStructureModal;
